import AddressForm, { getAddressValidation } from './AddressForm';

export default AddressForm;

export { getAddressValidation };



// WEBPACK FOOTER //
// ./src/modules/common/form/AddressForm/index.js